<template>
  <div style="overflow: hidden;">
    <!-- 顶部欢迎及注册登录按钮导航 -->
    <header-top />
    <!-- 顶部公司logo及导航栏 -->
    <div style="width:100%;height:100px;">
      <div class="logoNav">
        <!-- 左侧logo -->
        <img src="../../assets/img/weigaoLogo.png" width="200" style="margin-top:30px;">

        <!-- 右侧小图标 -->
        <img src="../../assets/img/home/head-bg.png" style="position: absolute;right: 0;bottom: 0;" width="450">
        <!-- <img src="../../assets/img/home/homelogoHeadRight.png"> -->
      </div>
    </div>
    <!-- 导航栏 -->
    <nav-head></nav-head>
    <div>
      <el-row>
        <el-col :span="12" style="max-height: 1140px">
          <div class="zlBaseInfo">
            <div class="zlBaseInfo-title">
              <el-button type="primary" style="margin-top: 2px; float: right" @click="downloadFile">下载文件</el-button>
              <h1 class="zlBaseInfo-title-h1">{{zlInfo.name}} - {{zlInfo.applicationNumber}}</h1>
              <span class="zlBaseInfo-title-span">{{zlInfo.foreignName}}</span>
              <br/>
              <span style="font-size: 12px; color:#666 ">申请号：{{zlInfo.applicationNumber}} 申请日：{{zlInfo.applicantDate}}</span>
            </div>
            <!--摘要-->
            <div class="zlBaseInfo-zy">
              <span style="font-size: 16px;font-weight: bold;">摘要：</span>
              <span class="zy">{{zlInfo.absrtact.slice(7)}}</span>
              <br/>
              <br/>
              <span style="font-size: 16px;font-weight: bold;">Abstract：</span>
              <span class="zy">{{zlInfo.original.slice(7)}}</span>
            </div>
            <div class="zlBaseInfo-div1">
              <span style="font-size: 14px;font-weight: bold;">申请人：</span>
              <span style="font-size: 14px; color: #1ab2ff">{{zlInfo.applicant}}</span>
              <br/>
              <span style="font-size: 14px;font-weight: bold;">分类号：</span>
              <span style="font-size: 14px; color: #1ab2ff">{{zlInfo.ipcClassify}}</span>
            </div>
            <div class="zlBaseInfo-div2">
              <el-descriptions title="相关信息" :column="1" :size="medium" border>
                <el-descriptions-item  label="公开号">{{zlInfo.openNumber}}</el-descriptions-item>
                <el-descriptions-item  label="公开日">{{zlInfo.openDate}}</el-descriptions-item>
                <el-descriptions-item  label="代理机构">{{zlInfo.agencies}}</el-descriptions-item>
                <el-descriptions-item  label="代理人">{{zlInfo.agent}}</el-descriptions-item>
                <el-descriptions-item  label="同族专利"  class-name="my-class" label-class-name="my-label">
                    {{zlInfo.patentFamily}}
                </el-descriptions-item>
                <el-descriptions-item  label="引用文献" class-name="my-class" label-class-name="my-label">{{zlInfo.citedCitations}}</el-descriptions-item>
                <el-descriptions-item  label="被引用文献" class-name="my-class" label-class-name="my-label">{{zlInfo.beCitedPatents}}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="max-height: 1140px">
          <!--显示两个按钮，切换pdf和附图-->
          <el-row style="margin-top: 20px">
            <el-button type="primary" style="margin-top: 2px; float: right" @click="pdfShow=true">预览文件</el-button>
            <el-button type="success" style="margin-top: 2px; float: right" @click="pdfShow=false">查看附图</el-button>
            <span style="font-size: 12px;font-weight: bold;color:red;margin-top: 7px;margin-left: 5px"  v-show="!pdfShow">
              点击图片进入预览模式时，可以通过方向按键翻页和放大缩小
            </span>
          </el-row>
          <div class="pdfDiv" v-show="pdfShow">
            <VuePdfEmbed
                :source="pdfSrc"
                :scale="scale"
                v-for="page in totalPages"
                :page="page"
                :key="page"
                @page-loaded="onPageLoaded"
                @num-pages="onNumPages"
            />
          </div>
          <div class="imgDiv" v-show="!pdfShow">
<!--            <img v-for="(item,index) in imgSrcArr" :src="item" :key="index" class="imgFile" />-->
            <el-image
                class="imgFile"
                v-for="(item,index) in imgSrcArr" :src="item"
                :preview-src-list="imgSrcArr">
            </el-image>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { createLoadingTask } from 'vue3-pdfjs';
import HeaderTop from "@/components/headerTop/headerTop.vue"
import NavHead from "@/components/navHead/navHead.vue"
import VuePdfEmbed from 'vue-pdf-embed'

export default {
  name: "zlDetail",
  components: {NavHead, HeaderTop, VuePdfEmbed},
  data() {
    return {
      queryId: 1,
      currentPage: 1,
      scale: 2,
      totalPages: 0,
      pdfShow: true,
      zlInfo: {
        name: '',
        applicationNumber: '',
        foreignName: '',
        absrtact: '摘要(中文)：',
        original: '摘要(英文)：',
        applicant: '',
        ipcClassify: '',
        openNumber: '',
        applicantDate: '',
        openDate: '',
        agencies: '',
        agent: '',
        patentFamily: '',
        citedCitations: '',
        beCitedPatents: '',
        filePath: ''
      },
      pdfSrc: '',
      imgSrcArr: []
    }
  },
  mounted() {
    console.log('组件已挂载');
    this.queryId = JSON.parse(this.$route.params.queryId).id
    this.getZlDetail()

  },
  watch: {
    $route(to, from) {
      this.queryId = JSON.parse(this.$route.params.queryId).id
      this.getZlDetail()
    }
  },
  methods: {
    // 下载文件
    download(obj, name, suffix) {
      const url = window.URL.createObjectURL(new Blob([obj]))
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      const fileName = parseTime(new Date()) + '-' + name + '.' + suffix
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    downloadFile() {
      const service = axios.create()
      var url = ""
      if (this.zlInfo.filePath.split(".")[1] === 'pdf'){
        url = 'http://47.104.169.175:81/file/'+this.zlInfo.filePath
      }else {
        url = 'http://47.104.169.175:81/file/'+this.zlInfo.filePath+'.pdf'
      }
      //axios 下载文件
      service({
        url: url,
        method: 'get',
        responseType: 'blob',
      }).then((res) => {
        console.log(res)
        const blob = new Blob([res.data], {type: 'application/pdf;charset-UTF-8'});
        const fileName = this.zlInfo.filePath+'.pdf';
        const downloadElement = document.createElement('a');
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
        this.$message({
          message: '下载成功',
          type: 'success'
        })
      })
      // window.open(this.pdfSrc)
    },
    getZlDetail() {
      this.axios.get('/api/patentJournals/findZLById', {params: {id: this.queryId}}).then(res => {
        this.zlInfo = res.data.data
        console.log(this.zlInfo)
        console.log(this.zlInfo.filePath)
        // this.pdfSrc = 'http://localhost:8080/file/'+this.zlInfo.filePath+'.pdf'
        if (this.zlInfo.filePath.split(".")[1] === 'pdf'){
          this.pdfSrc = 'http://47.104.169.175:81/file/'+this.zlInfo.filePath
        }else {
          this.pdfSrc = 'http://47.104.169.175:81/file/'+this.zlInfo.filePath+'.pdf'
        }
        if (this.zlInfo.figuresUrls !== null && this.zlInfo.figuresUrls !== '') {
          this.imgSrcArr = this.zlInfo.figuresUrls.split(';')
        }
        // this.pdfSrc = 'http://localhost:8080/file/123.pdf'
        const loadingTask = createLoadingTask(this.pdfSrc)
        loadingTask.promise.then((pdf) => {
          // debugger
          this.totalPages = pdf.numPages
          // debugger
        })
      })
    },
    onPageLoaded(event, pageNumber, page) {
      console.log(`Page ${pageNumber} loaded`);
    },
    onNumPages(event, pages) {
      this.totalPages = pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  }
}
</script>

<style scoped>
.zlBaseInfo {
  flex: 1;
  margin-top: 20px;
  padding-bottom: 20px;
  overflow: auto;
  height: 100%;
  border-right: 2px solid rgba(216, 217, 220, 0.92);
}
.pdfDiv{
  flex: 1;
  margin-top: 20px;
  padding-bottom: 20px;
  overflow: auto;
  height: 100%;
}
.imgDiv{
  flex: 1;
  margin-top: 20px;
  padding-bottom: 20px;
  overflow: auto;
  height: 100%;
}
.imgFile{
  width: 20%;
  height: 20%;
  border: 1px solid #ccc;
  margin-left: 10px;
}
.zlBaseInfo-title {
  margin-left: 20px;
}
.zlBaseInfo-title-h1 {
  display: block;
  font: bold 22px "宋体";
  margin: 0 0 5px;
}
.zlBaseInfo-title-span {
  font-size: 12px;
}
.zlBaseInfo-zy {
  border-top: 1px dashed #000;
  margin-left: 20px;
  padding-top: 20px;
}
.zy {
  font-size: 14px;
}
.zlBaseInfo-div1 {
  margin-left: 20px;
  padding-top: 20px;
}
.zlBaseInfo-div2 {
  margin-left: 20px;
  padding-top: 20px;
 }

:deep(.my-label) {
  width: 100px;
  color: #999;
  font-weight: normal;
  background: #fff;
}
:deep(.my-class) {
  max-width: 200px;
  word-break: break-all;
  word-wrap: break-word;
}

</style>
